export default(a=>Array.isArray(a));


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-utils/src/type/is-array.js
// module id = null
// module chunks = 